import React from "react";
import { ComponentTheme } from "utils/enums";
import { toZonedDateTimeOrNow } from "utils/time-utils";
import { T } from "services/lang/LanguageService";
import { Instant, ZoneId } from "@js-joda/core";
import { getTextColor, monthsArray } from "../charts/utils";

interface NoDataInCurrentMonthProps {
  tz: ZoneId;
  refTime: Instant;
  theme?: ComponentTheme;
}

const NoDataInCurrentMonth = ({ tz, refTime, theme }: NoDataInCurrentMonthProps) => {
  const currentMonth = toZonedDateTimeOrNow(tz, refTime);
  const monthIndex = currentMonth.month().value() - 1;
  const monthName = monthsArray[monthIndex] ?? "";

  return (
    <div
      style={{ color: getTextColor(theme), fontSize: "13px" }}
    >{`${T("label.no-data-in")} ${monthName}`}</div>
  );
};

export default NoDataInCurrentMonth;
